import { createContext } from "react";

export const CampaignContext = createContext({
    cvsData: [],
    csvErrors: [],
    setCsvData: () => {},
    setCsvErrors: () => {}
});
